/*global require, document, window, console */
const MAPJS = require('../src/npm-main'),
	jQuery = require('jquery'),
	themeProvider = require('./theme'),
	themeProvider2 = require('./theme2'),
	testMap = require('./example-map'),
	content = MAPJS.content,
	init = function () {
		'use strict';
		let domMapController = false;
		const container = jQuery('#container'),
			idea = content(testMap),
			touchEnabled = false,
			mapModel = new MAPJS.MapModel([]),
			themeJson = themeProvider.default || MAPJS.defaultTheme,
			themeJson2 = themeProvider2.default || MAPJS.defaultTheme,
			theme2 = new MAPJS.Theme(themeJson2),
			theme = new MAPJS.Theme(themeJson);
		let currentTheme = theme; // Set default theme
		const themeProvider3 = require('./argument-mapping'),
			themeProvider4 = require('./compact');
	  
	  	const themeJson3 = themeProvider3.default || MAPJS.defaultTheme,
			themeJson4 = themeProvider4.default || MAPJS.defaultTheme,
			theme3 = new MAPJS.Theme(themeJson3),
			theme4 = new MAPJS.Theme(themeJson4);

			let getTheme = () => currentTheme;
			function switchTheme(selectedTheme) {
				let tjson;
				switch (selectedTheme) {
					case 'theme1':
						currentTheme = theme;
						tjson = themeJson;
						break;
					case 'theme2':
						currentTheme = theme2;
						tjson = themeJson2;
						break;
					case 'theme3':
						currentTheme = theme3;
						tjson = themeJson3;
						break;
					case 'theme4':
						currentTheme = theme4;
						tjson = themeJson4;
						break;
					default:
						console.error('Invalid theme selected');
				}
				// Re-render the map with the new theme
				getTheme = () => currentTheme;
				layoutThemeStyle(tjson);
				mapModel.setIdea(mapModel.getIdea());
				const typeSelector = jQuery('#nodeType');
				typeSelector.empty(); 
				const option = jQuery('<option></option>')
				.val("")
				.text("Choose Group");
			typeSelector.append(option);
				let attrGroupNodes = findAttrGroupNodes(tjson);
				attrGroupNodes.forEach(nodeName => {
					const option = jQuery('<option></option>')
						.val(nodeName)
						.text(nodeName);
					typeSelector.append(option);
				});
			}
		jQuery.fn.attachmentEditorWidget = function (mapModel) {
			return this.each(function () {
				mapModel.addEventListener('attachmentOpened', function (nodeId, attachment) {
					mapModel.setAttachment(
						'attachmentEditorWidget',
						nodeId, {
							contentType: 'text/html',
							content: window.prompt('attachment', attachment && attachment.content)
						});
				});
			});
		};
		function findAttrGroupNodes(themeJson) {
			const attrGroupNodes = [];
		
			if (themeJson && themeJson.node && Array.isArray(themeJson.node)) {
				themeJson.node.forEach(node => {
					if (node.name && node.name.startsWith('attr_group_')) {
						const trimmedName = node.name.substring(11);  // Trim the 'attr_group_' prefix
            			attrGroupNodes.push(trimmedName);
					}
				});
			}
		
			return attrGroupNodes;
		}
		const typeSelector = jQuery('#nodeType');
		typeSelector.on('change',function() {
			const selectedNodeType = jQuery(this).val();  // Get the value of the selected option
			// Call your function here, passing the selected node type as a parameter
			mapModel.setGroupSubidea('click',mapModel.getCurrentlySelectedIdeaId(),{group:selectedNodeType});
		});
		typeSelector.empty();
		const option = jQuery('<option></option>')
				.val("")
				.text("Choose Group");
			typeSelector.append(option);
		let attrGroupNodes = findAttrGroupNodes(themeJson);
		attrGroupNodes.forEach(nodeName => {
			const option = jQuery('<option></option>')
				.val(nodeName)
				.text(nodeName);
			typeSelector.append(option);
		});
		window.layoutThemeStyle = function (themeJson) {
			const themeCSS = themeJson && new MAPJS.ThemeProcessor().process(themeJson).css;
			if (!themeCSS) {
				return false;
			}
		
			let styleTag = jQuery('#themeCSS');
			if (styleTag.length === 0) {
				styleTag = jQuery('<style id="themeCSS" type="text/css"></style>').appendTo('head');
			}
			styleTag.text(themeCSS);
			return true;
		};
		
		window.content = content;
		window.onerror = window.alert;
		window.jQuery = jQuery;

		container.domMapWidget(console, mapModel, touchEnabled);

		domMapController = new MAPJS.DomMapController(
			mapModel,
			container.find('[data-mapjs-role=stage]'),
			touchEnabled,
			undefined, // resourceTranslator
			getTheme
		);
		//jQuery('#themecss').themeCssWidget(themeProvider, new MAPJS.ThemeProcessor(), mapModel, domMapController);
		// activityLog, mapModel, touchEnabled, imageInsertController, dragContainer, centerSelectedNodeOnOrientationChange

		jQuery('body').attachmentEditorWidget(mapModel);
		layoutThemeStyle(themeJson);
		mapModel.setIdea(idea);


		jQuery('#linkEditWidget').linkEditWidget(mapModel);
		window.mapModel = mapModel;
		document.querySelector('.arrow').addEventListener('click', function () {
			this.classList.toggle('active');
		});
		// Add event listener to handle theme switching
		jQuery('#themeSelector').on("change", function () {
			const selectedTheme = jQuery(this).val();
			switchTheme(selectedTheme);
		});


		container.on('drop', function (e) {
			const dataTransfer = e.originalEvent.dataTransfer;
			e.stopPropagation();
			e.preventDefault();
			if (dataTransfer && dataTransfer.files && dataTransfer.files.length > 0) {
				const fileInfo = dataTransfer.files[0];
				if (/\.me$/.test(fileInfo.name)) {
					const oFReader = new window.FileReader();
					oFReader.onload = function (oFREvent) {
						if(confirm("Are you sure you want to load "+ fileInfo.name+"?")){
							mapModel.setIdea(content(JSON.parse(oFREvent.target.result)));
						}
					};
					oFReader.readAsText(fileInfo, 'UTF-8');
				}
			}
		});
	};
document.addEventListener('DOMContentLoaded', init);
